import { PaymentType } from "@/api-v3";

const ROUTE_PREFIX: Record<PaymentType, string> = {
  [PaymentType.stipend]: "/stipend",
  [PaymentType.micropayment]: "/micropayment",
  [PaymentType.receipt_claim]: "/receipt",
  [PaymentType.mileage_claim]: "/mileage",
};

export const paymentTypeToRoute = (
  type: PaymentType,
  id: string | number
): string => `${ROUTE_PREFIX[type]}/${id}`;
